<template>
  <b-row>
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/honey.gif" />
    </vue-element-loading>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <b-row slot="header">
            <b-col cols="12" md="3">List of Supervisors</b-col>
            <b-col cols="6" md="2" offset-md="7">
              <b-button v-b-modal.modal-add @click="add"
                >Add Supervisor</b-button
              >
              <!-- <b-modal hide-footer id="modal-add" title="Add Supervisor">
                <addHoney />
              </b-modal> -->
            </b-col>
          </b-row>
          <div v-if="userRole == 'Admin'" class="row">
            <div class="row col-md-12 pl-3 pr-3 pb-3">
              <div class="col-md-3">
                <div class="form-group">
                  <label
                    for="exampleInputEmail1"
                    style="text-align: left !important"
                    >Please Select the Username</label
                  >
                  <select
                    class="filter pt-2 pb-2"
                    style="width: 100% !important"
                    v-model="userid"
                  >
                    <option value disabled selected>Choose a Username</option>
                    <option
                      v-for="itm in users"
                      :key="itm._id"
                      v-bind:value="itm._id"
                    >
                      {{ itm.username }}
                    </option>
                    <option v-bind:value="null">None</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div v-if="data.length > 0">
            <b-table
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              responsive="sm"
              :items="data"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              class="table-responsive cntus"
            >
              <template
                id="pdcy"
                slot="photo"
                slot-scope="item"
                style="text-align: center"
              >
                <img
                  v-if="item.item.photo"
                  v-bind:src="baseURL + item.item.photo"
                  width="50px"
                  height="50px"
                />
                <p v-else>No Image</p>
              </template>
              <template
                id="pdcy1"
                slot="firstname"
                slot-scope="item"
                style="text-align: center"
              >
                <p v-if="item.item.firstname">
                  {{ item.item.firstname }}
                  {{ item.item.lastname }}
                </p>
                <p v-else>Nil</p>
              </template>
              <template slot="_id" slot-scope="data">
                <!-- <span style="padding-left: 20px !important">
                  <router-link :to="'/apiaryDetails/' + data.item._id">
                    <b-button class="px-4" variant="success"
                      >View Details
                    </b-button>
                  </router-link>
                </span> -->
                <!-- <span style="padding-left:20px!important;">
                  <router-link :to="'/edituser/'+data.item._id ">
                    <b-button class="text-white" variant="info">
                      <i class="fa fa-edit"></i>
                    </b-button>
                  </router-link>
                </span> -->
                <span style="padding-left:20px!important;">
                  <b-button variant="danger" @click="delSupervisor(data.item._id)">
                    Remove
                  </b-button>
                </span>  
              </template>
            </b-table>
             <nav>
            <b-pagination
              size="sm"
              :total-rows="getRowCount(data)"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Prev"
              next-text="Next"
              hide-goto-end-buttons
            />
          </nav>
          </div>
          <div v-else>
            <p>No List Found</p>
          </div>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
// import addHoney from "../Inventory/addHoney";
import store from '../../store'
export default {
  //  components: {
  //   addHoney,
  // },
  name: "Users",
  props: {
    caption: {
      type: String,
      default: "List of Inventoies",
    },
    hover: {
      type: Boolean,
      default: true,
    },
    striped: {
      type: Boolean,
      default: true,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      items: [
        {
          key: "honeytype",
          label: "Honey Type",
          sortable: false,
          thClass: " cntus",
          tdClass: "cntus ",
        },
        {
          key: "amount",
          label: "Amount",
          sortable: false,
          thClass: " cntus",
          tdClass: "cntus ",
        },
        {
          key: "price",
          label: "Price",
          sortable: false,
          thClass: " cntus",
          tdClass: "cntus ",
        },
        {
          label: " Action",
          key: "_id",
          sortable: false,
          thClass: "cntus",
          tdClass: "cntus ",
        },
      ],
      type: localStorage.getItem("type"),
      userRole: localStorage.getItem("userRole"),
    
      errors: [],
      data: [],
      users: [],
      inventory: [],
      userid: null,
      source: null,
      status: null,
      from: null,
      to: null,
      statusList: ["Active", "Reset"],
      fields: [
        {
          key: "firstname",
          label: "Name",
          sortable: false,
          thClass: " cntus",
          tdClass: "cntus ",
        },
        {
          key: "phone",
          label: "Phone",
          sortable: false,
          thClass: " cntus",
          tdClass: "cntus ",
        },
        {
          key: "email",
          label: "Email",
          sortable: false,
          thClass: " cntus",
          tdClass: "cntus ",
        },
        {
          key: "locationname",
          label: "Location Name",
          sortable: false,
          thClass: " cntus",
          tdClass: "cntus ",
        },
        {
          key: "photo",
          label: "Profile Pic",
          sortable: false,
          thClass: " cntus",
          tdClass: "cntus ",
        },

        {
          label: " Action",
          key: "_id",
          sortable: false,
          thClass: "cntus",
          tdClass: "cntus ",
        },
      ],
      currentPage: 1,
      additem: [],
      setitem: [],
      perPage: 20,
      totalRows: 0,
      addmodal: false,
      setmodal: false,
      appLoading: false,
      keyword: "",
      source: null,
      amount: null,
      price: null,
      honeytype: null,
    };
  },
  computed:{
    userData()
    {
      return store.state.userData
    }
  },
  beforeMount() {
    if (this.colonyid !== "nodata" && this.userid !== "nodata") {
      // avoiding passing nodata defined variable 'no data' in url to route
      this.colony = this.colonyid;
      this.userid = this.userid;
    }
  },
  mounted: function () {
    this.getList();
    this.getUsersList();
  },
  watch: {
    userid: function () {
      this.getList();
    },
    currentPage() {
      this.getList();
    },
  },
  methods: {
    getList() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/mysupervisors",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          user: this.userid,
          count: this.perPage,
          page: this.currentPage,
        },
      })
        .then((response) => {
          this.appLoading = false;

          if (response.data.status === true) {
            this.data = response.data.data;
            for (var i = 0; i < this.data.length; i++) {
              var dt = this.data[i].createddate.slice(0, 10);

              this.data[i].createddate = dt;
            }
            this.appLoading = false;
          } else if (response.data.status === false) {
            this.appLoading = false;
          }
        })
        .catch((e) => {
          this.appLoading = false;
          this.errors.push(e);
          this.msg = "failed";
        });
    },
    delSupervisor(val) {
      this.appLoading = true;
      if (confirm("Are you sure?")) {
        this.appLoading = true;
        var data1 = {};
        data1["id"] = val
        axios({
          method: "POST",
          data: data1,
          url: "/user/removesupervisor",
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
        })
          .then((response) => {
            this.appLoading = false;
            if (response.data.status) {
              this.getList();
              alert("Removed Successfully")
            } else {
              this.appLoading = false;
              alert(response.data.msg)
              // this.$router.push({ name: "userlist" });
            }
          })
          .catch((err) => {
            this.appLoading = false;
            this.errors.push(err);
            this.$router.push({ name: "userlist" });
          });
      } else this.getList();
    },
    add() {
      this.$router.push("/supervisorAdd/");
    },
    set(item) {
      this.setitem = item;
      this.setmodal = true;
    },
    addResource() {
      this.appLoading = true;
      var data = {};
      data["honeytype"] = this.additem.honeytype;
      data["source"] = this.source;
      data["amount"] = this.amount;
      axios({
        url: "/inventory/add",
        //url: "https://wtiadmin.in/resource/add",

        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.rid = response.data.data._id;
            this.add = [];
            if (this.selectedFile) this.uploadImage();
            else {
              this.$bvModal.hide("modal-add");
              this.selectedFile = null;
              this.previewUrl = null;
              this.getList();
            }
          } else this.appLoading = false;
        })
        .catch((e) => {
          this.errors.push(e);
          this.appLoading = false;
        });
    },
    setPrice() {
      this.appLoading = true;
      var data = {};
      data["honeytype"] = this.setitem.honeytype;
      data["price"] = this.price;
      axios({
        url: "/inventory/setprice",
        //url: "https://wtiadmin.in/resource/add",

        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.rid = response.data.data._id;
            this.add = [];
            if (this.selectedFile) this.uploadImage();
            else {
              this.$bvModal.hide("modal-set");
              this.selectedFile = null;
              this.previewUrl = null;
              this.getList();
            }
          } else this.appLoading = false;
        })
        .catch((e) => {
          this.errors.push(e);
          this.appLoading = false;
        });
    },
    getUsersList() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/allUsers",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: { kay: this.key, type: "User", count: 0, page: 0 },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status === true) {
            this.users = response.data.data;
            this.appLoading = false;
          } else if (response.data.status === false) {
            this.appLoading = false;
          }
        })
        .catch((e) => {
          this.appLoading = false;
          this.errors.push(e);
          this.msg = "failed";
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var month = dt.getMonth() + 1;
      var year = dt.getFullYear();
      var strTime = month + "-" + day + "-" + year;
      return strTime;
    },
    getRowCount(data) {
      return data.length;
    },
    // userLink(id) {
    //   return `users/${id.toString()}`;
    // },
    // rowClicked(data) {
    //   const userLink = this.userLink(data._id);
    //   this.$router.push({ path: userLink });
    // }
  },
};
</script>

<style >
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
.cntus {
  text-align: center !important;
}
.we {
  width: 80px !important;
}
.we2 {
  min-width: 200px !important;
}
.item_title {
  font-weight: bold;
  font-size: 14px;
}
.item_value {
  font-size: 13px;
}
</style>
